// extracted by mini-css-extract-plugin
export var calculatorLayout = "bB_fn";
export var dataPanel = "bB_fq";
export var filterPanel = "bB_fp";
export var sticky = "bB_fr";